<script lang="ts" setup>
  import { computed, onMounted, ref } from 'vue';
  import { useStore } from 'vuex';
  import { themingCssClass } from "../../mixins/theming-mixin"
  import { recProps } from '../../mixins/rec-component';
  import SimpleButton from "vue/applications/frontend/components/simple-button.vue"

  const props = defineProps({...recProps()});
  const emit = defineEmits(["submit"]);

  const store = useStore();
  const currentAreaPointer = ref<number>(0);

  onMounted(() => {
   store.commit("updateCurrentAreaKey", props.description.areas[0].key);
  });

  const activeAreaKey = computed(() => store.state.exam.currentAreaKey);
  const activeAreaIndex = computed(() => {
    let index = 0;
    for (const area of props.description.areas) {
      if (area.key === activeAreaKey.value) {
        return index;
      }
      index += 1;
    }
    return index;
  });

  const isLast = computed(() => activeAreaIndex.value + 1 == props.description.areas.length);

  const isFirst = computed(() => activeAreaIndex.value == 0)

  const next = () => {
    const nextIndex =
      (activeAreaIndex.value + 1) % props.description.areas.length;
    store.commit(
      "updateCurrentAreaKey",
      props.description.areas[nextIndex].key,
    );
  };

  const prev = () => {
    const prevIndex =
      (props.description.areas.length + activeAreaIndex.value - 1) %
      props.description.areas.length;
    store.commit(
      "updateCurrentAreaKey",
      props.description.areas[prevIndex].key,
    );
  };

  const submit = () => {
    if (!props.description.readonly) {
      emit("submit");
    } else {
      console.error("Submitting is not allowed for a readonly form");
    }
  };

  const submitAsDraft = () => {
    if (!props.description.readonly) {
      emit("submit-as-draft");
    } else {
      console.error("Submitting as draft is not allowed for a readonly form");
    }
  };
</script>

<template>
  <div class="components__progress-area">
    <div
      v-for="area in description.areas"
      v-bind:key="area.key"
      class="progress-single-area print--show"
      v-bind:class="{ inactive: area.key !== activeAreaKey }"
    >
      <div
        class="area-header print--avoid-break-page-after"
        v-bind:class="[themingCssClass('normal')]"
        v-if="area.area_title || area.area_subtitle"
      >
        <div class="area-title" v-if="area.area_title">
          {{ area.area_title }}
        </div>
        <div class="area-subtitle" v-if="area.area_subtitle">
          {{ area.area_subtitle }}
        </div>
      </div>
      <component
        v-bind:is="area.component"
        v-bind:description="area"
        v-on:submit="$emit('submit')"
      />
    </div>
    <div class="button-container print--hide">
      <div class="button-prev">
        <SimpleButton
          use-theming
          v-if="!isFirst"
          class="button-a"
          v-on:main-action="prev"
          >Zurück</SimpleButton
        >
      </div>
      <div class="button-next print--hide">
        <template v-if="isLast && !description.readonly">
          <div class="button-container--inner">
            <template v-if="description.exam_is_draft">
              <SimpleButton
                use-theming
                class="button-a"
                v-on:main-action="submitAsDraft"
                >Als Entwurf speichern</SimpleButton
              >
            </template>

            <SimpleButton
              use-theming
              class="button-a"
              v-on:main-action="submit"
              filled
              >Speichern</SimpleButton
            >
          </div>
        </template>
        <template v-else-if="!isLast">
          <SimpleButton use-theming class="button-a" v-on:main-action="next"
            >Weiter</SimpleButton
          >
        </template>
      </div>
    </div>
    <div v-if="isLast && !description.readonly && description.exam_is_draft" class="save-as-draft-explanation">
      Wenn Sie den Bogen als Entwurf speichern, ist er zunächst nur für Sie sichtbar. Sie können den Bogen nach dem Speichern jederzeit bearbeiten.
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~stylesheets/frontend/variables/colors";

.components__progress-area {
  .progress-single-area {
    &.inactive {
      display: none;
    }

    @media print {
      margin-top: 15px;
    }
  }
  .area-header {
    font-size: 18px;
    margin-bottom: 15px;

    .area-subtitle {
      margin-top: 6px;
      font-size: 16px;
      color: $color-default;
    }
  }
  .button-container {
    display: flex;
    margin-top: 15px;

    .button-prev {
    }

    .button-next {
      margin-left: auto;

      .button-container--inner {
        display: flex;
      }
    }

    .button-a {
      font-size: 14px;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }

    .button-a--small {
      font-size: 12px;
      padding-top: 3px;
      padding-bottom: 2px;

      i {
        font-size: 16px;
      }
    }

    .print-button {
      margin-top: 15px;
    }

    .button-content {
      display: flex;
      align-items: center;
    }

    .button-label {
      margin-left: 5px;
      line-height: 1;
    }
  }

  .save-as-draft-explanation {
    margin-top: 20px;
  }
}
</style>
